import './TypeOfChargeInfo.scss';

interface TypeOfChargeInfoProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
}

const TypeOfChargeInfo = ({ title, description }: TypeOfChargeInfoProps) => {
  return (
    <article className="info">
      <h1>{title}</h1>
      <p>{description}</p>
    </article>
  );
};

export default TypeOfChargeInfo;
